/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S1_TitleInputs */

const en_landing_guide_s1_title = /** @type {(inputs: Landing_Guide_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Ideogram 4.5?`)
};

const zh_landing_guide_s1_title = /** @type {(inputs: Landing_Guide_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 Ideogram 4.5？`)
};

/**
* | output |
* | --- |
* | "What is Ideogram 4.5?" |
*
* @param {Landing_Guide_S1_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s1_title = /** @type {((inputs?: Landing_Guide_S1_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S1_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s1_title(inputs)
	return zh_landing_guide_s1_title(inputs)
});
export { landing_guide_s1_title as "landing.guide.s1_title" }